export enum Locale {
  en = "en",
  zhCN = "zhCN",
}
